import { useMemo } from "react";
import { usePlayerHealth } from "../src/stores/usePlayerHealth";

const HEART_PATH = "M12 21.35l-1.4-1.28C5.36 15.36 2 12.24 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.74-3.36 6.86-8.6 11.57L12 21.35z";

export default function PlayerHealthHUD() {
  const maxHearts = usePlayerHealth((state) => state.maxHearts);
  const currentHearts = usePlayerHealth((state) => state.currentHearts);
  const isDamageFlashing = usePlayerHealth((state) => state.isDamageFlashing);

  const hearts = useMemo(
    () => Array.from({ length: maxHearts }, (_, index) => index < currentHearts),
    [maxHearts, currentHearts]
  );

  return (
    <div className={`player-hud${isDamageFlashing ? " player-hud--damage" : ""}`}>
      <div
        className="player-hud__hearts"
        role="status"
        aria-label={`Vida ${currentHearts} de ${maxHearts}`}
      >
        {hearts.map((filled, index) => (
          <svg
            key={index}
            className={`heart-icon${filled ? " heart-icon--full" : " heart-icon--empty"}`}
            viewBox="0 0 24 24"
            width="24"
            height="24"
            aria-hidden="true"
          >
            <path d={HEART_PATH} />
          </svg>
        ))}
      </div>
    </div>
  );
}
